<template>
  <v-tabs color="grey" background-color="grey lighten-4">
    <v-tabs-slider />
    <v-tab class="text-none grey--text">
      {{ $t('PROFILE.ADDITIONAL_INFO') }}
    </v-tab>
    <v-tab v-if="$can('sensitive-data')" class="text-none grey--text">
      {{ $t('PROFILE.MEDICAL_INFO') }}
    </v-tab>
    <v-tab class="text-none grey--text">
      {{ $t('EREPORTER.NAME') }}
    </v-tab>
    <v-tab class="text-none grey--text">
      {{ $t('PERSONS.BILLING') }}
    </v-tab>
    <v-tab v-if="!isCreated" class="text-none grey--text">
      {{ $t('ADDRESSES.ITEMS') }}
    </v-tab>
    <v-tab class="text-none grey--text">
      {{ $t('PERSONS.DATA_PROTECTION') }}
    </v-tab>
    <v-tab-item>
      <additional-info-form
        v-model="form.personal_profile"
        :readonly="readonly"
        :errors="errors.createInstanceByNamespace('personal_profile')"
        @input="emitter"
        @update-prop="updatePropWrapPrefix(...arguments, 'personal_profile')"
      />
    </v-tab-item>
    <v-tab-item v-if="$can('sensitive-data')">
      <medical-info-form
        v-model="form.personal_profile"
        :readonly="readonly"
        :errors="errors.createInstanceByNamespace('personal_profile')"
        @input="emitter"
        @update-prop="updatePropWrapPrefix(...arguments, 'personal_profile')"
      />
    </v-tab-item>
    <v-tab-item>
      <v-list dense>
        <v-list-item>
          <span class="text-body-1 grey--text pr-2">
            {{ $t('PROFILE.ABACUS_NUMBER') }}
          </span>
          <span class="text-subtitle-2">
            {{ form.abacus_id || $t('ITEM.EMPTY') }}
          </span>
        </v-list-item>
        <v-list-item>
          <span class="text-body-1 grey--text pr-2">
            {{ $t('PROFILE.ABACUS_REMINDER') }}
          </span>
          <span class="text-subtitle-2">
            {{ form.reminder_address || $t('ITEM.EMPTY') }}
          </span>
        </v-list-item>
      </v-list>
      <v-divider />
    </v-tab-item>
    <v-tab-item>
      <billing-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item v-if="!isCreated">
      <addresses-card :person-id="form.id" />
    </v-tab-item>
    <v-tab-item>
      <data-protection-form
        v-model="form.data_protection"
        :readonly="readonly"
        :person="form"
        :errors="errors.createInstanceByNamespace('data_protection')"
        @input="emitter"
        @update-prop="updatePropWrapPrefix(...arguments, 'data_protection')"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import DataProtectionForm from '@/modules/persons/components/forms/DataProtectionForm.vue';

export default {
  name: 'MainPersonTabsForm',

  components: {
    DataProtectionForm,
    AdditionalInfoForm: () =>
      import('@/modules/persons/components/forms/AdditionalInfoForm'),
    MedicalInfoForm: () =>
      import('@/modules/persons/components/forms/MedicalInfoForm'),
    BillingForm: () => import('@/modules/persons/components/forms/BillingForm'),
    AddressesCard: () =>
      import('@/modules/persons/components/Addresses/AddressesCard')
  },

  mixins: [formEditable],

  computed: {
    isCreated() {
      return !this.form.id;
    }
  }
};
</script>
